import { render, staticRenderFns } from "./datatable2.vue?vue&type=template&id=83d6daea"
import script from "./datatable2.vue?vue&type=script&lang=js"
export * from "./datatable2.vue?vue&type=script&lang=js"
import style0 from "./datatable2.vue?vue&type=style&index=0&id=83d6daea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports